"use strict";
/**
 * Shared models for the reusable in-app Feedback Survey widget (DEV-2363).
 *
 * A Survey is configured by Product from the internal Admin › Surveys page and
 * rendered in-app by the generic SurveyHost using the design-system
 * `FeedbackSurvey` component. Each submitted response is written to the flat
 * `survey_responses` collection (synced to PostHog via the managed Mongo
 * source). `survey_interactions` is internal bookkeeping that powers the
 * one-shot-per-user-per-feature rule and the cross-survey cool-off.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurveyInteractionType = exports.SurveyEventCountMode = exports.SurveyConditionType = exports.SurveyTriggerOperator = exports.SurveyDisplayScope = exports.SurveyStatus = void 0;
var SurveyStatus;
(function (SurveyStatus) {
    SurveyStatus["ACTIVE"] = "active";
    SurveyStatus["INACTIVE"] = "inactive";
    SurveyStatus["ARCHIVED"] = "archived";
})(SurveyStatus = exports.SurveyStatus || (exports.SurveyStatus = {}));
/**
 * Where the widget is allowed to render once the user is eligible.
 * - SPECIFIC_PAGE: only on `page_url` (the user must be on that page).
 * - ANYWHERE: on the next page load, wherever the user is.
 *
 * This is independent of the trigger — a survey can count sessions on one page
 * but display anywhere.
 */
var SurveyDisplayScope;
(function (SurveyDisplayScope) {
    SurveyDisplayScope["ANYWHERE"] = "anywhere";
    SurveyDisplayScope["SPECIFIC_PAGE"] = "specific_page";
})(SurveyDisplayScope = exports.SurveyDisplayScope || (exports.SurveyDisplayScope = {}));
var SurveyTriggerOperator;
(function (SurveyTriggerOperator) {
    SurveyTriggerOperator["AND"] = "AND";
    SurveyTriggerOperator["OR"] = "OR";
})(SurveyTriggerOperator = exports.SurveyTriggerOperator || (exports.SurveyTriggerOperator = {}));
var SurveyConditionType;
(function (SurveyConditionType) {
    /** N distinct browser sessions on a page (matched via PostHog `$pathname`). */
    SurveyConditionType["SESSION_COUNT"] = "session_count";
    /** A PostHog event fired N times (occurrences or distinct sessions). */
    SurveyConditionType["EVENT_COUNT"] = "event_count";
})(SurveyConditionType = exports.SurveyConditionType || (exports.SurveyConditionType = {}));
var SurveyEventCountMode;
(function (SurveyEventCountMode) {
    SurveyEventCountMode["OCCURRENCES"] = "occurrences";
    SurveyEventCountMode["DISTINCT_SESSIONS"] = "distinct_sessions";
})(SurveyEventCountMode = exports.SurveyEventCountMode || (exports.SurveyEventCountMode = {}));
var SurveyInteractionType;
(function (SurveyInteractionType) {
    SurveyInteractionType["SHOWN"] = "shown";
    SurveyInteractionType["DISMISSED"] = "dismissed";
    SurveyInteractionType["SUBMITTED"] = "submitted";
})(SurveyInteractionType = exports.SurveyInteractionType || (exports.SurveyInteractionType = {}));
